import { QuestionStatistics } from 'types/QuestionStatistics'
import { RootState } from 'stores/index'

export const getSelectedAnswers = (state: RootState) => state.selectedAnswers

export const getCompleteness: (state: RootState) => boolean = (
  state: RootState
) => state.isComplete || false

export const getSubmissionStatus: (
  state: RootState
) => 'fillingOut' | 'submitting' | 'delivered' | 'error' | string = (
  state: RootState
) => state.submissionStatus || 'fillingOut'

export const getStatistics: (
  state: RootState
) => QuestionStatistics | undefined = (state: RootState) =>
  (state.firebase && state.firebase.statistics) || undefined

export const getForm = (state: RootState) => state.form

export const getFirebaseErrorCode = (state: RootState) =>
  state.firebase &&
  state.firebase.firebaseError &&
  state.firebase.firebaseError.code
